import React from "react";
import iconBackground from "../img/icon-background-stars.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faEnvelope, faFeather, faHammer, faCode } from "@fortawesome/free-solid-svg-icons";
import i18next from 'i18next';

export const Menu = ({handleContentChange}) => {
    return (
        <>
            <div className="menu">
                <div className="navbar">
                    <button onClick={() => handleContentChange("about")} alt={i18next.t('aboutMe')} type="button" className="btn btn-background text-white menu-tooltip" style={{ backgroundImage: `url(${iconBackground})` }}>
                        <FontAwesomeIcon icon={faUser} size="2x" />
                    </button>
                    <button onClick={() => handleContentChange("technologies")} alt={i18next.t('technologies')} className="btn btn-background text-white menu-tooltip" style={{ backgroundImage: `url(${iconBackground})` }}>
                        <FontAwesomeIcon icon={faHammer} size="2x" />
                    </button>
                    <button onClick={() => handleContentChange("skills")} alt={i18next.t('softSkills')} className="btn btn-background text-white menu-tooltip" style={{ backgroundImage: `url(${iconBackground})` }} >
                        <FontAwesomeIcon icon={faFeather} size="2x" />
                    </button>
                    <button onClick={() => handleContentChange("projects")} alt={i18next.t('projects')} className="btn btn-background text-white menu-tooltip" style={{ backgroundImage: `url(${iconBackground})` }} >
                        <FontAwesomeIcon icon={faCode} size="2x" />
                    </button>
                    <button onClick={() => handleContentChange("contact")} alt={i18next.t('contact')} className="btn btn-background text-white menu-tooltip" style={{ backgroundImage: `url(${iconBackground})` }} >
                        <FontAwesomeIcon icon={faEnvelope} size="2x" />
                    </button>
                </div>
            </div>
        </>
    )
}

